var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col md:w-1/1 w-full"},[_c('vx-card',{attrs:{"title":"Approval Cancel"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('approval-cancel')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }